/**
 * Application configuration and constants
 */

// Colors
export const BG_COLOR = 0x344a58;
export const EDGE_COLOR = 0xe1c1e8;
export const USER_COLORS = [
  0xffd463, 0xfe9e0b, 0x64b308, 0x0095e4, 0xfffb01, 0xeb9f65, 0xfd4e53,
  0xdd381c, 0x63b10f, 0x93d6ff, 0x994c2e,
];
export const DJ_COLORS = [0x63b10f, 0x93d6ff, 0x994c2e];
export const LABEL_COLOR = 0xfffed5;
export const SIM_COLOR = 0x0097e6;

// Performance settings
export const FRAME_RATE = 24;
export const MAX_FRAME_TIME = 500;
export const MIN_MATCH = 0.3;

// Physics simulation settings
export const PHYSICS_SETTINGS = {
  timeStep: 0.5,
  dimensions: 2,
  gravity: -48,
  theta: 0.8,
  springLength: 30,
  springCoefficient: 0.8,
  dragCoefficient: 0.9,
  nodeMass: (nodeId, graph) => {
    const node = graph.getNode(nodeId);
    let mass = 1;
    if (node && node.data && node.data.playcount) {
      mass += node.data.playcount;
    }
    return mass;
  }
};

// API configuration
export const getApiBase = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://127.0.0.1:8000/';
  }
  return 'https://www.atomodo.com/lfmg/api/';
};
